import { FC, useState } from "react";
import type { MACDSettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "fastPeriod" | "slowPeriod" | "signalPeriod";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string }[] = [
  { key: "fastPeriod", label: "Fast Period" },
  { key: "slowPeriod", label: "Slow Period" },
  { key: "signalPeriod", label: "Signal Period" },
];

interface Props {
  settings: MACDSettings;
  onChange: (settings: MACDSettings) => void;
}

export const MACDInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    fastPeriod: String(settings.fastPeriod),
    slowPeriod: String(settings.slowPeriod),
    signalPeriod: String(settings.signalPeriod),
  });

  const handleChange = (key: InputKey, value: string) =>
    setValues((prev) => ({ ...prev, [key]: value }));

  const handleBlur = (key: InputKey) => {
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(1, parsed), 100);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={1}
            max={100}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key)}
          />
        </div>
      ))}
    </div>
  );
};
